export default __webpack_public_path__ + "static/media/folder.e0b82f06.png";